import './searchForm.css';

import InputText from "../Layouts/InputField/InputText/inputText";
import Navigation from "../Layouts/Navigation/navigation";
import SearchFilter from "./searchFilter";
import { useState } from 'react';
import InputSelect from '../Layouts/InputField/InputSelect/inputSelect';

export default function SearchForm({ formData, formUpdateHandler, filters, buttonSearchHandler, buttonClearHandler, subDiseaseLabel }) {
    const [navState, setNavState] = useState('domain');

    const navClickHandler = (e, newState) => {
        e.preventDefault();

        setNavState(newState);
    }

    return (
        <form>
            <InputText
                id="keyword"
                labelText="Search Term(s)"
                inputValue={formData.keyword}
                changeHandler={e => formUpdateHandler(e, 'keyword')}
            />
            {filters.subDisease.length > 1 && <InputSelect
                id="subDisease"
                labelText={subDiseaseLabel}
                selectedValue={formData.subDisease}
                changeHandler={e => formUpdateHandler(e, 'subDisease')}
                inputArr={filters.subDisease}
            />}
            <Navigation className="search-form-nav">
                <a href="#" className={navState === 'domain' ? 'active' : null} onClick={(e) => navClickHandler(e, 'domain')}>Domain Name</a>
                <a href="#" className={navState === 'subDomain' ? 'active' : null} onClick={(e) => navClickHandler(e, 'subDomain')}>Subdomain Name</a>
                <a href="#" className={navState === 'copyright' ? 'active' : null} onClick={(e) => navClickHandler(e, 'copyright')}>Copyright</a>
            </Navigation>
            <SearchFilter
                filterName={navState}
                filterList={filters[navState]}
                selectedValue={formData[navState]}
                changeHandler={e => formUpdateHandler(e, navState)}
            />
            <div className="button-section">
                <button type="submit" id="submit" value="Search" onClick={(e) => buttonSearchHandler(e)}>
                    Search
                </button>
                <button type="reset" id="clear" value="clear" onClick={(e) => buttonClearHandler(e)}>
                    Clear
                </button>
            </div>
        </form>
    );
}